if (!window.SwDragScroll) {
  const THRESHOLD = 8;

  const drag = {
    track: null,
    pointerId: null,
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    moved: false,
  };

  const clear = () => {
    if (drag.track) {
      drag.track.classList.remove('is-dragging');
      drag.track.style.scrollBehavior = '';
      drag.track.style.scrollSnapType = '';
    }
    drag.track = null;
    drag.pointerId = null;
    drag.moved = false;
  };

  const onPointerDown = (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const track = event.target.closest?.('.sw-scroll-track');
    if (!track || track.scrollWidth <= track.clientWidth + 1) return;
    drag.track = track;
    drag.pointerId = event.pointerId;
    drag.startX = event.clientX;
    drag.startY = event.clientY;
    drag.scrollLeft = track.scrollLeft;
    drag.moved = false;
  };

  const onPointerMove = (event) => {
    if (!drag.track || event.pointerId !== drag.pointerId) return;
    const dx = event.clientX - drag.startX;
    const dy = event.clientY - drag.startY;
    if (!drag.moved) {
      if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return;
      if (Math.abs(dy) > Math.abs(dx)) {
        clear();
        return;
      }
      drag.moved = true;
      drag.track.classList.add('is-dragging');
      drag.track.style.scrollBehavior = 'auto';
      drag.track.style.scrollSnapType = 'none';
      try {
        drag.track.setPointerCapture(event.pointerId);
      } catch (error) {
        /* The pointer can already be gone if the mouse left the window. */
      }
      window.getSelection()?.removeAllRanges();
    }
    drag.track.scrollLeft = drag.scrollLeft - dx;
  };

  const onPointerUp = (event) => {
    if (!drag.track || event.pointerId !== drag.pointerId) return;
    const track = drag.track;
    const moved = drag.moved;
    clear();
    if (!moved) return;

    const suppressClick = (clickEvent) => {
      document.removeEventListener('click', suppressClick, true);
      if (track.contains(clickEvent.target)) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
      }
    };
    document.addEventListener('click', suppressClick, true);
  };

  const onDragStart = (event) => {
    if (event.target.closest?.('.sw-scroll-track')) event.preventDefault();
  };

  document.addEventListener('pointerdown', onPointerDown);
  document.addEventListener('pointermove', onPointerMove);
  document.addEventListener('pointerup', onPointerUp);
  document.addEventListener('pointercancel', onPointerUp);
  document.addEventListener('dragstart', onDragStart);
  window.SwDragScroll = true;
}
